import type { RouteLocationNormalized } from 'vue-router';
import type { RouterListener } from './RouterListener';
import { useSidebarStore } from '@/vue/stores/sidebar';
import {
    isPlaylistSidebarName,
    shouldPreservePlaylistSidebarOnRouteChange,
} from '@/vue/features/review/playlist/helpers/playlistSidebar';

export default class SidebarClosingListener implements RouterListener {
    public onBeforeEach(
        to: RouteLocationNormalized,
        from: RouteLocationNormalized,
    ): boolean {
        const sidebarStore = useSidebarStore();
        if (!sidebarStore.hasSidebar) {
            return true;
        }

        if (sidebarStore.consumeRouteChangePreservation()) {
            return true;
        }

        const { sidebar } = sidebarStore;
        if (
            isPlaylistSidebarName(sidebar?.name)
            && shouldPreservePlaylistSidebarOnRouteChange(to, from)
        ) {
            return true;
        }

        sidebarStore.clearSidebar();

        return true;
    }
}
